let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bZ1FC")).then(() => parcelRequire('je1LG'));